import ParticipantList from './ParticipantList.container';

export default ParticipantList;
